export const RESOURCE_LINK_HTML_TAG = 'resource-link'
export const RESOURCE_LINK_NAME = 'superclassResourceLinkExtension'
